/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import React from 'react';
import {AppRoot, PageContainer} from './src/PageContainer';
import GlobalErrorBoundary from './src/Components/GlobalErrorBoundary';
import './src/polyfill';

const NO_LAYOUT_PATHS = ['/designs/'];

export const wrapPageElement = ({element, props}) => {
  if (NO_LAYOUT_PATHS.includes(props.path)) {
    return element;
  }
  return <PageContainer {...props}>{element}</PageContainer>;
};

export const wrapRootElement = ({element}) => {
  return (
    <GlobalErrorBoundary>
      <AppRoot>{element}</AppRoot>
    </GlobalErrorBoundary>
  );
};

// Gatsby V5 相容的 onRouteUpdate
export const onRouteUpdate = ({location, prevLocation}) => {
  const widget = document.querySelector('div[script-id="UOmW9"]');
  if (widget) {
    if (location.pathname.includes('/designs')) {
      widget.style.display = 'none';
    } else {
      widget.style.display = 'block';
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    console.log('路由更新:', location.pathname);
    console.log('前一個路由:', prevLocation ? prevLocation.pathname : null);
  }
};

// React 18 相容性設定 + 最後防線事件攔截（僅 production 啟用）
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    window.__GATSBY_INITIAL_PROPS = window.__GATSBY_INITIAL_PROPS || {};

    // 預載入 die-cut-editor
    const prefetchEditor = () =>
      import(/* webpackPrefetch: true */ '@sensationsprint/die-cut-editor');

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prefetchEditor, {timeout: 2000});
    } else {
      window.addEventListener('load', () => setTimeout(prefetchEditor, 1500), {
        once: true,
      });
    }

    if (process.env.NODE_ENV === 'production') {
      const to404 = () => {
        if (window.location.pathname !== '/404') {
          window.location.replace('/404');
        }
      };
      // 未處理的同步/資源錯誤
      window.addEventListener('error', to404);
      // 未處理的 Promise 拋錯
      window.addEventListener('unhandledrejection', to404);
    }
  }
};
